import auth from '../helper/auth'

const userRoutes = [

    {
        path: '/',
        name: 'Login',
        beforeEnter: auth.ifNotAuthenticated,
        component: () => import('../views/Login.vue')
    },

    {
        path: '/login',
        name: 'LoginForm',
        beforeEnter: auth.ifNotAuthenticated,
        component: () => import('../views/Login.vue')
    },

    {
        path: '/*',
        name: 'PageNotFound',
        component: () => import('../views/PageNotFound.vue')
    },
]

export default userRoutes